import isByteLength from 'validator/lib/isByteLength';

// checks whether the given string is in between 0 and max num of bytes for sql `TEXT` type
export const MAX_SQL_TEXT_BYTE_LENGTH = 65_535;
export function isMaxByteLength(val: string, maxLength: number): boolean {
	return isByteLength(val, { min: 0, max: maxLength });
}
